export default "__VITE_ASSET__C6N8X750__"